export default class PerformanceComment {
    id: number;
    commentText: string;
    authorId: number;
    authorFirstName: string;
    authorLastName: string;
    userId: number;
    commentDate: Date;
    isApproved: boolean;
    isEdited: boolean;
    editAuthorId: number;
    editAuthorFirstName: string;
    editAuthorLastName: string;
    editCommentDate: Date;
}



// WEBPACK FOOTER //
// ./src/models/PerformanceComment.ts